import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import modalclose from '../../../images/close1.png';
import './index.css';
import moment from 'moment';

const OrderSummaryGeneralModal = ({ isOpen, toggle, orderData }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered id="orderSummary">
      <ModalBody className="p-0">
        <div className="modalHeader mb-0">
          <div className="title">Order Summary ({orderData.business_name || 'N/A'})</div>
          <div className="closeButton">
            <img src={modalclose} alt="close" onClick={toggle} />
          </div>
        </div>
        <div className="bodyArea">
          <div className="details">
            <div className="details_flex">
              <div>
                <p>
                  <strong>Order Date : </strong>
                  {moment(orderData.order_date).format('lll') || 'N/A'}
                </p>
                <p>
                  <strong>Order On : </strong> {orderData.order_on || 'N/A'}
                </p>
                <p>
                  <strong>CNF Remarks : </strong> {orderData.action_reason || 'N/A'}
                </p>
                <p>
                  <strong>Order Summary Remark : </strong>{' '}
                  {orderData.order_remarks || 'N/A'}
                </p>
                <p>
                  <strong>Updated Order Remark : </strong>{' '}
                  {orderData.revision_order_remark || 'N/A'}
                </p>
              </div>
              <div>
                <p>
                  <strong>TM : </strong> {orderData.th || 'N/A'}
                </p>
                <p>
                  <strong>SH : </strong> {orderData.sh || 'N/A'}
                </p>
                <p>
                  <strong>NH : </strong> {orderData.nh || 'N/A'}
                </p>
                <p>
                  <strong>Territory : </strong> {orderData.territory || 'N/A'}
                </p>
              </div>
            </div>
          </div>
          <div
            className="details dispatch_Details"
            style={{ marginTop: '0.75rem' }}
          >
            <div className="title">Dispatch Details</div>
            <div className="details_data">
              <p>
                <strong>Transporter Name : </strong>
                {orderData.transporter_name || 'N/A'}
              </p>
              <p>
                <strong>LR Details/Dispatch Details : </strong>
                {orderData.lr_dispatch_details || 'N/A'}
              </p>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OrderSummaryGeneralModal;
